import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace UserApi {
    /**
    * 新增用户
    */
    export var AddUser = (body: any): Promise<any> => {
        return Post(`/msls/UserApi/createUser`, body);
    };
    /**
    * 用户列表
    */
    export var GetUserList = (query: any): Promise<any> => {
        return Get(`/msls/UserApi/userList?${qs.stringify(query)}`, {});
    };
    /**
    * 用户详情
    */
    export var GetUserDetail = (id: any): Promise<any> => {
        return Get(`/msls/UserApi/userDetail/${id}`, {});
    };
    /**
     * 修改用户
     */
    export var UpdateUser = (id: any, body: any): Promise<any> => {
        return Post(`/msls/UserApi/editUser/${id}`, body);
    };
    /**
     * 修改菜单权限
     */
    export var UpdatePermissions = (body: any): Promise<any> => {
        return Put(`/msls/UserApi/editWebMenus`, body);
    };
    /**
     * 修改数据权限
     */
    export var UpdateDataPermissions = (body: any): Promise<any> => {
        return Put(`/msls/UserApi/editDataPermissions`, body);
    };
    /**
     * 修改个人信息
     */
    export var editPersonalInfo = (id: any, body: any): Promise<any> => {
        return Put(`/msls/UserApi/editPersonalInfo/${id}`, body);
    };
    /**
     * 修改密码
     */
    export var UpdatePW = (body: any): Promise<any> => {
        return Put(`/msls/UserApi/updatePassword`, body);
    };
    /**
     * 重置密码
     */
    export var ResetPW = (body: any): Promise<any> => {
        return Put(`/msls/UserApi/resetPassword`, body);
    };
    /**
     * 删除用户
     */
    export var DeleteUser = (id: any): Promise<any> => {
        return Put(`/msls/UserApi/delete/${id}`, {});
    };



    // /**
    // * 获取验证码
    // */
    // export var GetCspUserCode = (body: any): Promise<any> => {
    //     return Get(`/csp/User/GetCode?${qs.stringify(body)}`, {});
    // };
    // /**
    // * 根据用户名和手机获取用户
    // */
    // export var GetCspUser = (body: any): Promise<any> => {
    //     return Get(`/csp/User/CheckUserForget?${qs.stringify(body)}`, {});
    // };
    // /**
    // * 验证手机验证码
    // */
    // export var CheckPhoneCode = (body: any): Promise<any> => {
    //     return Get(`/csp/User/CheckPhoneCode?${qs.stringify(body)}`, {});
    // };
    // /**
    //  * 忘记密码-修改密码
    //  */
    // export var ForgetUpdatePW = (body: any): Promise<any> => {
    //     return Put(`/csp/User/ForgetUpdatePassword`, body);
    // };
    // /**
    // * 获取所有权限
    // */
    // export var GetAllPermissions = (type: any): Promise<any> => {
    //     return Get(`/csp/User/allPermissions/${type}`, {});
    // };
    // /**
    // * 获取已有权限
    // */
    // export var GetOwnPermissions = (id: any): Promise<any> => {
    //     return Get(`/csp/User/userPermissions/${id}`, {});
    // };
}